import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Grid, Typography, TextField, Button } from '@mui/material';
import { getLogin, verifyMagicToken } from 'redux/actions/authAction';
import { companyDetails } from 'utils/companyDetails';
import { themeColors } from 'utils/themeColors';
import CommonForm from 'components/commonForm/CommonForm';
import Loader from 'components/loader/Loader';
import Otp from 'pages/auth/otp/Otp';
import login_hand from 'assets/images/login_hand.png';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state);
  const [searhParams, setSearchParamas] = useSearchParams();
  const Token = searhParams?.get('Token');
  
  // console.log("Login details"+userLogin.toString());
  // console.log("Token--->",Token)
  const isLoader = userLogin?.auth?.loading;

  const [onOtp, setOnOtp] = useState(false);
  const [emailValue, setEmailValue] = useState('');
  const [emailError, setEmailError] = useState('');

  const handleredirect = () => {
    navigate('/signup');
  };

  const onOtpPage = (val) => {
    setOnOtp(val);
  };

  const isVendorPresent = window.location.href.includes('citymanager');
  const isSubVendorPresent = window.location.href.includes('subvendor');
  useEffect(() => {
    if (Token) {
      localStorage.setItem('token', Token);
      dispatch(verifyMagicToken(Token));
    }
  }, [Token]);

  const loginForm = [
    {
      placeholder: ' Email ID',
      required: true,
      type: 'text',
      name: 'email',
      label: 'Email ID',
      star: '*',
      countrycode: false,
      gridSize: 12,
    },
  ];
  const loginFormSubVendor = [
    {
      placeholder: ' Email ID or Mobile Number ',
      required: true,
      type: 'text',
      name: 'mobileOrEmail',
      label: 'Email ID or Mobile Number',
      star: '*',
      countrycode: false,
      gridSize: 12,
    },
  ];

  const formValue = isSubVendorPresent ? loginFormSubVendor : loginForm;

  const onLogin = (data) => {
    localStorage.clear();
    const loginPayload = {
      userDetails: {
        // platform: 'AdminApp',
        mobileOrEmail: data.email,
        countryCode: data?.countryCode || '+91',
       },
       actionType: "login"
    };

    // dispatchEvent(call redux function: action -> saga -> reducer (update the store)
    dispatch(getLogin(loginPayload, navigate, setOnOtp));
  };



  return (
    <div>
      {onOtp === false && (
        <Box sm={{ flexGrow: 1 }} className="mobileRes loginMain">
          {Token ? (
            <Loader />
          ) : (
            <Grid container spacing={2} className="">
              {/* ---login Part--- */}
              <Grid item sm={6}>
                {/* ---login nav--- */}
                <Box
                  sx={{
                    display: { xs: 'none', sm: 'flex' },
                    alignItems: 'center',
                  }}
                  className="positionAbsolute"
                >
                  <img src={companyDetails?.companyLogo} className="logoImg" alt="otplogo" />
                </Box>
                {/* ---login input type--- */}
                <div className="loginInput mobileBg">
                  <Grid container className="justifyCenter" rowSpacing={4} sx={{ width: '100%' }}>
                    <Grid item xs={12} sm={10} className="textCenter">
                      <Grid item className='grideItemCenter'>
                        <img src={login_hand} alt="hand" />
                      </Grid>
                      <Grid item className="justifyCenter">
                        {isVendorPresent && !isSubVendorPresent ? (
                          <Typography
                            variant="head2"
                            className="fw700 colorPrimary"
                          >
                            Let's get started as
                            <span className="colorYellow">City Manager</span>
                          </Typography>
                        ) : isSubVendorPresent ? (
                          <Typography
                            variant="head2"
                            className="fw700 colorPrimary"
                          >
                            Let's get started as
                            <span className="colorYellow">Sub-Vendor</span>
                          </Typography>
                        ) : (
                          <Typography
                            variant="head2"
                            className="fw700 colorPrimary"
                          >
                            Let's get
                            <span className="colorYellow"> started</span>
                          </Typography>
                        )}
                      </Grid>
                      <Typography
                        variant={'body2'}
                        className="colorGrey fontInput fw400"
                      >
                        Enter your Login details below
                      </Typography>
                    </Grid>

                  <Grid item xs={12} sm={7} className="" sx={{ width: '100%' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        <Typography
                          sx={{
                            fontFamily: '"Poppins", sans-serif !important',
                            fontSize: '18px !important',
                            fontWeight: '400 !important',
                            color: '#282828 !important',
                            marginBlock: '10px !important',
                            textAlign: 'left',
                          }}
                        >
                          Email ID<span style={{ color: '#d32f2f' }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          placeholder="Email ID"
                          type="text"
                          value={emailValue}
                          onChange={(e) => {
                            setEmailValue(e.target.value);
                            setEmailError('');
                          }}
                          error={!!emailError}
                          helperText={emailError}
                          variant="outlined"
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '10px',
                              position: 'relative',
                              backgroundColor: 'white',
                              height: '55px',
                              '& fieldset': {
                                borderColor: '#CDCDCD',
                                borderWidth: '1px',
                              },
                              '&:hover fieldset': {
                                borderColor: '#CDCDCD',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#CDCDCD',
                                borderWidth: '1px',
                              },
                            },
                            '& .MuiInputBase-input': {
                              padding: '12px 12px',
                              fontSize: '16px',
                              color: '#333333',
                              height: '55px',
                              boxSizing: 'border-box',
                              '&::placeholder': {
                                color: '#999999',
                                opacity: 1,
                              },
                            },
                            '& .MuiFormHelperText-root': {
                              fontSize: '12px',
                              marginLeft: '2px',
                            },
                          }}
                        />
                      </Box>
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={() => {
                          if (!emailValue.trim()) {
                            setEmailError('Email ID is required');
                            return;
                          }
                          const data = isSubVendorPresent 
                            ? { mobileOrEmail: emailValue }
                            : { email: emailValue };
                          onLogin(data);
                        }}
                        disabled={isLoader}
                        sx={{
                          backgroundColor: emailValue.trim() ? `${themeColors.secondaryColor} !important` : '#9E9E9E !important',
                          height: '50px !important',
                          color: '#ffffff !important',
                          marginTop: '2rem !important',
                          fontWeight: '400 !important',
                          fontSize: '18px !important',
                          borderRadius: '10px !important',
                          textTransform: 'capitalize !important',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: emailValue.trim() ? themeColors.secondaryColor : '#757575 !important',
                            boxShadow: 'none',
                            opacity: 0.9,
                          },
                          '&:disabled': {
                            backgroundColor: '#E0E0E0 !important',
                            color: '#9E9E9E !important',
                          },
                        }}
                      >
                        {isLoader ? 'Loading...' : 'Login'}
                      </Button>
                    </Box>
                  </Grid>
                  </Grid>
                  {isSubVendorPresent ? (
                    <Typography
                      variant="body1"
                      className="colorGrey fontNormal"
                    >
                      Don't have an account ?
                      <span
                        className="colorBlue cursor"
                        onClick={handleredirect}
                      >
                        Signup now
                      </span>
                    </Typography>
                  ) : null}
                </div>
              </Grid>
              {/* ---Image Part--- */}
              <Grid
                item
                sm={6}
                sx={{ display: { xs: 'none', sm: 'flex' } }}
                className="bgImage"
              >
                <div className="loginBgImg"></div>
              </Grid>
            </Grid>
          )}
        </Box>
      )}
      {onOtp && <Otp onOtpPage={onOtpPage} />}
    </div>
  );
}